const parseJson = (str) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return null
  }
}

const save = (token, questionnaire) => {
  return localStorage.setItem(token, JSON.stringify(questionnaire))
}

const reset = (token, questionnaire) => {
  const storageQuestionnaire = parseJson(localStorage.getItem(token))

  if (storageQuestionnaire) {
    return {
      ...questionnaire,
      questions: questionnaire.questions.map(question => {
        const answer = storageQuestionnaire.questions.find(v => v._id === question._id)
        return {
          ...answer,
          ...question
        }
      })
    }
  } else {
    return questionnaire
  }
}

export default {
  save,
  reset
}